export default {
  lbl_add: 'Adjunta',
  lbl_documents: 'las evidencias que sean necesarias.',
  error_no_file: 'No ha adjuntado archivo.',
  error_invalid_attachment_extension: 'Extensión de archivo inválida.',
  create_attachment_file_number_alert: 'Sólo puedes agregar 3 archivos. Si desea continuar debe descartar un archivo',
  delete_attachment_success: 'Adjunto eliminado con éxito.',
  created_attachment_success: 'Adjunto creado con éxito.',
  find_file: 'Examinar',
  finalize: 'Finalizar'
}
